import { render } from "./MarketPlace.vue?vue&type=template&id=3fdd73b6"
import script from "./MarketPlace.vue?vue&type=script&lang=js"
export * from "./MarketPlace.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__